import queryString from 'query-string';
import { getSellerSubdomain } from './getSellerDomain';
import getCheckoutPreviewUrl from './getCheckoutPreviewUrl';
import { isDevelopment, isPreview as isPreviewEnv } from './env';

export default function getSubdomainCheckoutUrl(
  page = {},
  seller = {},
  { isTesting = false, isPreview = false } = {},
) {
  if (isDevelopment || isPreviewEnv) {
    return getCheckoutPreviewUrl(page, seller, { isTesting, isPreview });
  }

  if (!seller.name) return;

  const pageUrlId = page.slug || page._id;

  const domain = getSellerSubdomain(seller);

  const checkoutUrl = `${domain}/${pageUrlId}`;

  return queryString.stringifyUrl({
    url: checkoutUrl,
    query: {
      ...(isTesting && { testing: true }),
      ...(isPreview && { preview: true }),
    },
  });
}
